import React, {useState} from 'react';
import {Formik, Field, FormikProps} from 'formik';
import _ from 'lodash';
import classNames from 'classnames';

import {Form, Button, Modal, Popup} from '@components';
import validations from '@validations';
import utils from '@utils';
import constants from '@constants';
import mappings from '@mappings';
import resources from '@resources';
import {Props} from './types';
import * as handlers from './handlers';

import './index.scss';

const User: React.FC<Props> = props => {
  const initialValues = props.initialValues;
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div className="w__user-card">
      <div className="w__user-field">
        <Formik
          initialValues={initialValues}
          onSubmit={props.handleSubmit}
          validate={
            props.create ? validations.users.create : validations.users.update
          }
          enableReinitialize
        >
          {(formProps: FormikProps<any>) => {
            return (
              <div className="w__information-field">
                <div className="b__field-title">基本情報</div>
                <div className="w__form">
                  {props.users.detail.isEmailBounced && (
                    <div className="b__bounce-label">
                      このユーザーはメールの配信に失敗しているユーザーです。
                      <br />
                      メールの配信が失敗状態のユーザーは一度ユーザーを削除して、
                      <br />
                      再度正しいメールアドレスで新しくユーザーを作成する必要があります。
                    </div>
                  )}
                </div>
                <div className="w__form">
                  <div className="w__input sm first">
                    <Form.Label
                      disabled={props.detail}
                      text="姓"
                      required={!props.detail}
                    />
                    <Field
                      component={Form.Input}
                      name="lastName"
                      placeholder="姓"
                      disabled={
                        props.detail ||
                        formProps.isSubmitting ||
                        resources.users.getDisabled(
                          props.me,
                          props.users.detail
                        )
                      }
                    />
                  </div>
                  <div className="w__input sm">
                    <Form.Label
                      disabled={
                        props.detail ||
                        resources.users.getDisabled(
                          props.me,
                          props.users.detail
                        )
                      }
                      text="名"
                      required={!props.detail}
                    />
                    <Field
                      component={Form.Input}
                      name="firstName"
                      placeholder="名"
                      disabled={
                        props.detail ||
                        formProps.isSubmitting ||
                        resources.users.getDisabled(
                          props.me,
                          props.users.detail
                        )
                      }
                    />
                  </div>
                </div>
                <div className="w__form">
                  <div className="w__input sm first">
                    <Form.Label
                      disabled={
                        props.detail ||
                        resources.users.getDisabled(
                          props.me,
                          props.users.detail
                        )
                      }
                      text="セイ"
                      required={!props.detail}
                    />
                    <Field
                      component={Form.Input}
                      name="lastKana"
                      placeholder="セイ"
                      disabled={
                        props.detail ||
                        formProps.isSubmitting ||
                        resources.users.getDisabled(
                          props.me,
                          props.users.detail
                        )
                      }
                    />
                  </div>
                  <div className="w__input sm">
                    <Form.Label
                      disabled={
                        props.detail ||
                        resources.users.getDisabled(
                          props.me,
                          props.users.detail
                        )
                      }
                      text="メイ"
                      required={!props.detail}
                    />
                    <Field
                      component={Form.Input}
                      name="firstKana"
                      disabled={
                        props.detail ||
                        formProps.isSubmitting ||
                        resources.users.getDisabled(
                          props.me,
                          props.users.detail
                        )
                      }
                      placeholder="メイ"
                    />
                  </div>
                </div>
                <div className="w__form">
                  <div className="w__input sm">
                    <Form.Label disabled={props.detail} text="性別" />
                    {_.isNull(initialValues.gender) && props.detail ? (
                      <Field
                        component={Form.Input}
                        name="gender"
                        disabled={
                          props.detail ||
                          formProps.isSubmitting ||
                          resources.users.getDisabled(
                            props.me,
                            props.users.detail
                          )
                        }
                        placeholder="性別"
                      />
                    ) : (
                      <Field
                        component={Form.Dropdown}
                        placeholder="性別"
                        name="gender"
                        disabled={
                          props.detail ||
                          formProps.isSubmitting ||
                          resources.users.getDisabled(
                            props.me,
                            props.users.detail
                          )
                        }
                        options={utils.mappings.createSelections(
                          mappings.gender
                        )}
                      />
                    )}
                  </div>
                </div>
                <div className="w__form">
                  <div className="w__input">
                    <Form.Label disabled={props.detail} text="生年月日" />
                    <div className="w__birthdate">
                      <Field
                        component={Form.Dropdown}
                        placeholder="年"
                        name="birthyear"
                        disabled={
                          props.detail ||
                          formProps.isSubmitting ||
                          resources.users.getDisabled(
                            props.me,
                            props.users.detail
                          )
                        }
                        options={resources.users.getBirthSelections('years')}
                        size="sm"
                        hideErrorMessage
                      />
                      <Field
                        component={Form.Dropdown}
                        placeholder="月"
                        name="birthmonth"
                        disabled={
                          props.detail ||
                          formProps.isSubmitting ||
                          resources.users.getDisabled(
                            props.me,
                            props.users.detail
                          )
                        }
                        options={resources.users.getBirthSelections('months')}
                        size="sm"
                        hideErrorMessage
                      />
                      <Field
                        component={Form.Dropdown}
                        placeholder="日"
                        name="birthday"
                        disabled={
                          props.detail ||
                          formProps.isSubmitting ||
                          resources.users.getDisabled(
                            props.me,
                            props.users.detail
                          )
                        }
                        options={resources.users.getBirthSelections('days', {
                          currentYear: formProps.values.birthyear,
                          currentMonth: formProps.values.birthmonth,
                        })}
                        size="sm"
                        hideErrorMessage
                      />
                    </div>

                    <Form.Error>
                      {resources.users.getBirthError(
                        formProps.errors,
                        formProps.touched,
                        {
                          year: 'birthyear',
                          month: 'birthmonth',
                          day: 'birthday',
                        }
                      )}
                    </Form.Error>
                  </div>
                </div>
                <div className="w__form">
                  <div className="w__input">
                    <Form.Label
                      disabled={
                        props.detail ||
                        resources.users.getDisabled(
                          props.me,
                          props.users.detail
                        )
                      }
                      text="メールアドレス"
                      required={!props.detail}
                    />
                    <Field
                      component={Form.Input}
                      name="email"
                      placeholder="メールアドレス"
                      disabled={
                        resources.users.getDisabled(
                          props.me,
                          props.users.detail,
                          props.update
                        ) ||
                        props.detail ||
                        props.myPage ||
                        formProps.isSubmitting
                      }
                    />
                  </div>
                </div>
                <div className="w__form">
                  <div className="w__input">
                    <div
                      className={classNames('b__title-label', {
                        popup:
                          props.me.plan !== constants.PLAN.FREE &&
                          !props.detail,
                      })}
                    >
                      <Form.Label disabled={props.detail} text="携帯番号" />
                      {/* 詳細ページ以外かつ有料プランを契約しているユーザーのみに表示させる */}
                      {props.me.plan !== constants.PLAN.FREE && !props.detail && (
                        <Popup.Normal
                          content="携帯番号を登録していないユーザー、020, 070, 080,
                      090以外の携帯番号のユーザーにはSMSを送信できません。"
                        />
                      )}
                    </div>
                    <Field
                      component={Form.Input}
                      name="phoneNumber"
                      placeholder="携帯番号"
                      disabled={
                        props.detail ||
                        formProps.isSubmitting ||
                        resources.users.getDisabled(
                          props.me,
                          props.users.detail
                        )
                      }
                      maxLength={13}
                    />
                  </div>
                </div>
                <div className="w__form">
                  <div className="w__input sm">
                    <Form.Label
                      disabled={
                        props.detail ||
                        resources.users.getDisabled(
                          props.me,
                          props.users.detail
                        )
                      }
                      text="地域"
                      required={!props.detail}
                    />
                    <Field
                      component={Form.Dropdown}
                      name="prefecture"
                      placeholder="地域"
                      options={utils.mappings.createSelections(
                        mappings.prefectures
                      )}
                      disabled={
                        props.detail ||
                        formProps.isSubmitting ||
                        resources.users.getDisabled(
                          props.me,
                          props.users.detail
                        )
                      }
                    />
                  </div>
                </div>
                <div className="w__form">
                  <div className="w__input sm">
                    <Form.Label
                      disabled={
                        props.detail ||
                        resources.users.getDisabled(
                          props.me,
                          props.users.detail
                        )
                      }
                      text="所属組織"
                    />
                    <Field
                      component={Form.Input}
                      placeholder="所属組織"
                      name="organization"
                      disabled={
                        props.detail ||
                        formProps.isSubmitting ||
                        resources.users.getDisabled(
                          props.me,
                          props.users.detail
                        )
                      }
                      maxLength={30}
                    />
                  </div>
                </div>
                <div className="w__form">
                  <div className="w__input sm">
                    <Form.Label
                      disabled={
                        props.detail ||
                        resources.users.getDisabled(
                          props.me,
                          props.users.detail
                        )
                      }
                      text="役職"
                    />
                    <Field
                      component={Form.Input}
                      placeholder="役職"
                      name="position"
                      disabled={
                        props.detail ||
                        formProps.isSubmitting ||
                        resources.users.getDisabled(
                          props.me,
                          props.users.detail
                        )
                      }
                      maxLength={30}
                    />
                  </div>
                </div>
                <div className="w__form">
                  <div className="w__input sm">
                    <Form.Label text="権限" disabled required={!props.detail} />
                    <Field
                      component={Form.Dropdown}
                      name="authLevel"
                      placeholder="権限"
                      options={handlers.getSelections(
                        props.myPage,
                        props.detail,
                        props.users.detail.authLevel
                      )}
                      disabled={
                        props.detail ||
                        props.myPage ||
                        props.update ||
                        resources.users.getDisabled(
                          props.me,
                          props.users.detail
                        )
                      }
                    />
                  </div>
                </div>

                {props.isOption ? (
                  <div className="w__form">
                    <div className="w__input sm">
                      <Form.Label disabled text="プラン" />
                      <Field
                        component={Form.Input}
                        name="plan"
                        placeholder="オプション"
                        disabled
                      />
                    </div>
                  </div>
                ) : null}
                {props.detail ? null : (
                  <div className="w__submit-buttons">
                    <Button.Normal
                      text={props.submitText}
                      color="yellow"
                      disabled={
                        props.detail ||
                        props.users.detail.isEmailBounced ||
                        formProps.isSubmitting ||
                        resources.users.getDisabled(
                          props.me,
                          props.users.detail
                        )
                      }
                      loading={formProps.isSubmitting}
                      onClick={() => formProps.handleSubmit()}
                    />
                  </div>
                )}
                {/* メールアドレスで登録しているユーザー以外表示させない */}
                {props.changePassword && !props.me.provider && (
                  <div className="w__change-button">
                    <Button.Normal
                      text="パスワードを変更する"
                      color="green"
                      disabled={formProps.isSubmitting}
                      onClick={props.setIsModal}
                    />
                  </div>
                )}

                {/* typeガードをかける */}
                {props.isCreateMailModal && props.handleCloseModal && (
                  <Modal.SendSuccessMail
                    history={props.history}
                    isModal={props.isCreateMailModal}
                    handleCloseModal={props.handleCloseModal}
                    title="登録完了の通知"
                    onClick={() => {
                      handlers.sendSuccessMail(
                        formProps.values,
                        props.history,
                        setIsLoading
                      );
                    }}
                    loading={isLoading}
                  />
                )}
              </div>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default User;
